var _excluded = ["id", "top"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@okee-uikit/react-utils';
import { useCell, useColumnGroup, useIsGroup } from '../../hooks/table';
import React from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
export function TableHeadRender(props) {
  var id = props.id,
      _props$top = props.top,
      top = _props$top === void 0 ? false : _props$top,
      extra = _objectWithoutProperties(props, _excluded);

  var isGroup = useIsGroup(id);

  if (isGroup == null) {
    return null;
  }

  if (isGroup) {
    return React.createElement(Group, _objectSpread({
      key: id,
      top: top,
      id: id
    }, extra));
  }

  return React.createElement(Cell, _objectSpread({
    key: id,
    id: id,
    top: top
  }, extra));
}

function Cell(props) {
  var id = props.id,
      headGroupHeight = props.headGroupHeight,
      headRowHeight = props.headRowHeight,
      deep = props.deep,
      top = props.top;

  var _useCell = useCell(id),
      renderHead = _useCell.renderHead,
      className = _useCell.className,
      width = _useCell.width,
      isFirstShownColumn = _useCell.isFirstShownColumn,
      isLastShownColumn = _useCell.isLastShownColumn;

  var cls = classnames(usePrefixCls('table-cell', {
    head: true,
    first: isFirstShownColumn,
    last: isLastShownColumn,
    leaf: true,
    bottom: true,
    top: top
  }), className);
  return React.createElement("div", {
    className: cls,
    style: {
      height: "".concat(headGroupHeight * (deep - 1) + headRowHeight, "px"),
      width: "".concat(width, "px")
    }
  }, renderHead());
}

function Group(props) {
  var id = props.id,
      headRowHeight = props.headRowHeight,
      headGroupHeight = props.headGroupHeight,
      deep = props.deep,
      top = props.top;

  var _useColumnGroup = useColumnGroup(id),
      columnKeys = _useColumnGroup.columnKeys,
      renderHead = _useColumnGroup.renderHead,
      isFirstShownColumn = _useColumnGroup.isFirstShownColumn,
      isLastShownColumn = _useColumnGroup.isLastShownColumn;

  var cls = usePrefixCls('table-head-group');
  var titleCls = usePrefixCls('table-cell', {
    head: true,
    group: true,
    first: isFirstShownColumn,
    last: isLastShownColumn,
    top: top
  });
  var contentCls = usePrefixCls('table-column-group');
  var columns = columnKeys.map(function (item) {
    return React.createElement(TableHeadRender, {
      id: item,
      key: item,
      headRowHeight: headRowHeight,
      headGroupHeight: headGroupHeight,
      deep: deep - 1
    });
  });
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: titleCls,
    style: {
      height: "".concat(headGroupHeight, "px")
    }
  }, renderHead()), React.createElement("div", {
    className: contentCls
  }, columns));
}